import { Link, useNavigate } from 'react-router-dom';
import { LogOut, User, Settings, History as HistoryIcon, Home as HomeIcon } from 'lucide-react';
import { clearAuth, getUser } from '../lib/api';

export function Layout({ children }: { children: React.ReactNode }) {
  const user = getUser();
  const navigate = useNavigate();

  const logout = () => {
    clearAuth();
    navigate('/login');
  };

  return (
    <div className="min-h-dvh bg-slate-50">
      <header className="sticky top-0 z-10 border-b border-slate-200 bg-white/95 backdrop-blur">
        <nav className="mx-auto flex h-14 max-w-4xl items-center gap-2 px-4">
          <Link
            to={user?.role === 'admin' ? '/admin' : user ? '/app' : '/'}
            className="flex items-center gap-2 font-semibold text-sky-600"
          >
            <span className="inline-flex h-7 w-7 items-center justify-center rounded-md bg-sky-600 text-sm text-white">
              算
            </span>
            <span className="hidden text-base sm:inline">珠心算识别</span>
          </Link>
          <div className="flex-1" />
          {user?.role === 'user' && (
            <>
              <Link
                to="/app"
                className="inline-flex h-9 items-center gap-1 rounded-md px-2 text-sm font-medium text-slate-600 hover:bg-slate-100 sm:px-3"
              >
                <HomeIcon className="h-4 w-4" />
                <span className="hidden sm:inline">首页</span>
              </Link>
              <Link
                to="/history"
                className="inline-flex h-9 items-center gap-1 rounded-md px-2 text-sm font-medium text-slate-600 hover:bg-slate-100 sm:px-3"
              >
                <HistoryIcon className="h-4 w-4" />
                <span className="hidden sm:inline">历史</span>
              </Link>
            </>
          )}
          {user?.role === 'admin' && (
            <Link
              to="/admin"
              className="inline-flex h-9 items-center gap-1 rounded-md px-2 text-sm font-medium text-slate-600 hover:bg-slate-100 sm:px-3"
            >
              <Settings className="h-4 w-4" />
              <span className="hidden sm:inline">管理</span>
            </Link>
          )}
          <span className="hidden text-sm text-slate-500 sm:inline-flex sm:items-center sm:gap-1">
            <User className="h-4 w-4" />
            {user?.username ?? ''}
          </span>
          <button
            type="button"
            onClick={logout}
            className="inline-flex h-9 items-center gap-1 rounded-md px-2 text-sm font-medium text-slate-600 hover:bg-slate-100 sm:px-3"
            aria-label="登出"
          >
            <LogOut className="h-4 w-4" />
            <span className="hidden sm:inline">登出</span>
          </button>
        </nav>
      </header>
      <main className="mx-auto max-w-4xl px-4 py-6">{children}</main>
    </div>
  );
}
